import { createSlice } from "@reduxjs/toolkit";
import { stateEnum } from "../constants/enum";

const { polishSize } = stateEnum;

let initialState = {
    detailParams: {},
    isNewEntry: false
};


const polishSizeSlice = createSlice({
    name: polishSize,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload
          },
        resetDetail: (state) => {
            state.detailParams = {};
            state.isNewEntry = true;
        },
    },
    
});


export const { setNewEntryMode,setDetailParams, resetDetail } = polishSizeSlice.actions;
export default polishSizeSlice.reducer;
